// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"analysis-panel_thoughtProcess__fC9+i","closeBtn":"analysis-panel_closeBtn__Kbdxc","pdfZone":"analysis-panel_pdfZone__jCN8L"};